/** Persistance du contexte USD (magasin(s) en rate_id 2 + taux HTG/USD). */

export const USD_STORAGE = {
  HAS_USD: 'businessHasUsdStore',
  RATE: 'usdSalesRate',
}

export function persistUsdContext(hasUsd, salesRate) {
  localStorage.setItem(USD_STORAGE.HAS_USD, hasUsd ? '1' : '0')
  const ok = hasUsd && salesRate != null && salesRate !== '' && parseFloat(salesRate) > 0
  if (ok) {
    localStorage.setItem(USD_STORAGE.RATE, String(salesRate))
  } else {
    localStorage.removeItem(USD_STORAGE.RATE)
  }
}

export function clearUsdContext() {
  localStorage.removeItem(USD_STORAGE.HAS_USD)
  localStorage.removeItem(USD_STORAGE.RATE)
}

export function readUsdContext() {
  return {
    hasUsd: localStorage.getItem(USD_STORAGE.HAS_USD) === '1',
    rate: parseFloat(localStorage.getItem(USD_STORAGE.RATE) || '0') || 0,
  }
}

/**
 * Montant produit → équivalent USD.
 * rate_id 1 = HTG → USD = montant / taux (HTG pour 1 USD).
 * rate_id 2 = déjà en USD.
 */
export function amountToUsd(amount, productRateId, salesRate) {
  const n = parseFloat(amount)
  const r = parseFloat(salesRate)
  if (isNaN(n) || !r || r <= 0) return null
  const rid = productRateId != null ? Number(productRateId) : 1
  if (rid === 2) return n
  return n / r
}
